export const version = "address/5.6.1";
//# sourceMappingURL=_version.js.map